import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { Businesses } from '@vendasta/sales';
import { SalesActivityApiService } from '../sales/sales-activity/sales-activity-api.service';
import { SalesToolHostService } from '../sales/salestool.host.service';
import { AssignedSalespersonCardComponent } from './assigned-salesperson-card/assigned-salesperson-card.component';
import { AssignedSalespersonService } from './assigned-salesperson.service';
import { ContactUsComponent } from './contact-us/contact-us.component';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { GalaxyButtonGroupModule } from '@vendasta/galaxy/button-group';
import { ProductAnalyticsModule } from '@vendasta/product-analytics';
import { AssignedSalespersonNavFooterCardComponent } from './assigned-salesperson-nav-footer-card/assigned-salesperson-nav-footer-card.component';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { InboxButtonModule } from '@galaxy/conversation/button';

@NgModule({
  declarations: [AssignedSalespersonCardComponent, AssignedSalespersonNavFooterCardComponent, ContactUsComponent],
  exports: [AssignedSalespersonCardComponent, AssignedSalespersonNavFooterCardComponent, ContactUsComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    GalaxyButtonGroupModule,
    MatIconModule,
    MatFormFieldModule,
    FormsModule,
    TranslateModule,
    MatProgressSpinnerModule,
    A11yModule,
    ProductAnalyticsModule,
    InboxButtonModule,
  ],
  providers: [Businesses, SalesToolHostService, SalesActivityApiService, AssignedSalespersonService],
})
export class AssignedSalespersonModule {}
